import type { Layer, TagsManager } from 'dxf-writer'
import DatabaseObject from 'dxf-writer/src/DatabaseObject.js'

type Point2D = {
  x: number
  y: number
}

/**
 * DXF SOLID 实体（AcDbTrace），用三/四个顶点描述实心填充面，
 * 主要用于实心箭头与三角形填充。
 */
export default class Solid extends DatabaseObject {
  layer!: Layer
  lineType: string = 'ByLayer'
  lineWidth: number = -1
  trueColor: number | undefined

  constructor(
    public p1: Point2D,
    public p2: Point2D,
    public p3: Point2D,
    public p4: Point2D = p3
  ) {
    super(['AcDbEntity', 'AcDbTrace'])
  }

  tags(manager: TagsManager) {
    manager.push(0, 'SOLID')
    super.tags(manager)
    manager.push(8, this.layer.name)
    manager.push(6, this.lineType)
    manager.push(62, 256)
    manager.push(370, this.lineWidth)
    if (this.trueColor !== undefined) {
      manager.push(420, this.trueColor)
    }

    manager.point(this.p1.x, this.p1.y)

    manager.push(11, this.p2.x)
    manager.push(21, this.p2.y)
    manager.push(31, 0)

    manager.push(12, this.p3.x)
    manager.push(22, this.p3.y)
    manager.push(32, 0)

    manager.push(13, this.p4.x)
    manager.push(23, this.p4.y)
    manager.push(33, 0)
  }
}
